import * as styles from '../FirstResponder.module.css';
import { renderText } from '../LivePreview/liveMetricDisplay';
import { LiveAuditRow, LivePage } from '../LivePreview/liveViewModel';
import PreviewPagination from '../LivePreview/PreviewPagination';

/*
 * Server-shaped audit page + pagination. Originally extracted so the (now-retired)
 * ConnectedConsole didn't re-inline the table LiveConsole.tsx rendered inline. GRAVY-10373
 * convergence, Phase 5: this is now the ONE canonical implementation — imported by
 * Presentation/PilotSettingsSection.tsx, which both the frozen preview (via LiveConsole.tsx) and
 * the real connected container render — no more independent inline copy anywhere.
 */

type Props = {
  page: LivePage<LiveAuditRow>;
  onPageChange: (page: number) => void;
};

const AuditTable = ({ page, onPageChange }: Props) => (
  <div data-testid="flp-audit">
    <div className={styles.k}>Change audit</div>
    <div className={styles.tableScroll}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>When</th>
            <th>Who</th>
            <th>Setting</th>
            <th>From → To</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {page.items.length === 0 ? (
            <tr>
              <td colSpan={5} className={styles.muted} style={{ padding: 16 }}>
                No recorded changes.
              </td>
            </tr>
          ) : (
            page.items.map((r, i) => (
              <tr key={`${r.at}-${r.setting}-${i}`} className={styles.zebra}>
                <td className={styles.muted}>{r.at}</td>
                <td className={styles.muted}>{r.who}</td>
                <td className={styles.strong}>{r.setting}</td>
                <td className={styles.muted}>
                  {r.from === null ? 'none' : renderText(r.from)} →{' '}
                  {renderText(r.to)}
                </td>
                <td className={styles.muted}>{r.reason}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
    <PreviewPagination
      pagination={page.pagination}
      onPageChange={onPageChange}
      itemsLabel="changes"
    />
  </div>
);

export default AuditTable;
